// extracted by mini-css-extract-plugin
export default {"wrapper":"_1Elmj","dot":"_26uaD","tooltip-content":"_2yVLI","tooltipContent":"_2yVLI"};